import { AbiFunction } from 'ox';
import { formatUnits } from '@train-protocol/sdk';
import { htlcFunctions } from '../../abi.js';
import { ZERO_ADDRESS, FUNCTION_SIGNATURES } from '../../constants.js';
import { toTronHex } from '../../address.js';
import { encodeParams, hex, normalizeAddress } from '../../utils.js';
import { findUserLockedEvent } from '../helpers.js';
export async function getUserLockDetails(rpc, params) {
    const { id, contractAddress, txId, decimals } = params;
    const contractHex = toTronHex(contractAddress);
    // Use a dummy owner for read calls
    const dummyOwner = contractHex;
    const calldata = AbiFunction.encodeData(htlcFunctions.getUserLock, [hex(id)]);
    const parameter = encodeParams(calldata);
    const raw = await rpc.triggerConstantContract(contractHex, FUNCTION_SIGNATURES.getUserLock, parameter, dummyOwner);
    const result = AbiFunction.decodeResult(htlcFunctions.getUserLock, hex('0x' + raw));
    const parsedResult = resolveUserLock(result, id, decimals);
    if (!parsedResult)
        return null;
    let blockTimestamp;
    let eventDerivedData = {};
    if (txId) {
        try {
            const txInfo = await rpc.getTransactionInfoById(txId);
            if (txInfo?.log) {
                const lockEvent = findUserLockedEvent(txInfo.log, id);
                if (lockEvent) {
                    eventDerivedData = pickEventDerivedData(lockEvent);
                }
                if (txInfo.blockTimeStamp) {
                    blockTimestamp = txInfo.blockTimeStamp;
                }
            }
        }
        catch (e) {
            console.error('Error fetching userData from tx info:', e);
        }
    }
    return { ...eventDerivedData, ...parsedResult, blockTimestamp };
}
export function resolveUserLock(result, id, decimals) {
    if (result.sender === ZERO_ADDRESS)
        return null;
    if (!result.timelock || (result.timelock && (result.timelock.toString()).length < 9))
        return null;
    return {
        hashlock: id,
        amount: Number(formatUnits(BigInt(result.amount), decimals)),
        secret: BigInt(result.secret),
        sender: normalizeAddress(result.sender),
        recipient: normalizeAddress(result.recipient),
        token: normalizeAddress(result.token),
        timelock: Number(result.timelock),
        status: Number(result.status),
    };
}
export const eventDerivedDataKeys = [
    'userData', 'solverData',
    'reward', 'rewardToken', 'rewardRecipient', 'rewardTimelock',
    'dstChain', 'dstAddress', 'dstAmount', 'dstToken',
];
export function pickEventDerivedData(event) {
    const data = {};
    for (const key of eventDerivedDataKeys) {
        if (key in event && event[key] != null) {
            data[key] = event[key];
        }
    }
    return data;
}
